import React from "react";
import {
  Datagrid,
  FunctionField,
  List,
  TextField,
  TopToolbar,
  useTranslate,
} from "react-admin";

const MainPageList = () => {
  const translate = useTranslate();

  return (
    <List pagination={false} filters={[]} actions={<TopToolbar></TopToolbar>}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <FunctionField
          label="mainPage.title"
          render={() => translate("mainPage.name")}
        />
      </Datagrid>
    </List>
  );
};

export default MainPageList;
